import React from "react";
import "../AboutTaxes.css";
import DefectiveReturn from "../../../../assets/faq-section-139-9.jpeg";

function Section139_9() {
  return (
    <section className="blog-container">
      <div className="blog-header">
        <div className="blog-author">
          <div className="blog-author-profile">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/b/b9/Dollar_sign_in_circle_cleaned_%28PD_version%29.green.svg"
              alt="TaxSarthi"
            />
          </div>
          <div className="blog-author-name">TaxSarthi</div>
        </div>
        <div className="blog-date">12 July, 2023</div>
      </div>
      <hr />
      <div className="blog-title">
        Notice for defective return u/s 139(9) of the Income Tax Act
      </div>
      <hr />
      <div className="blog-content">
        <div className="content-section">
          <div className="content-subheading">
            By which mode will I receive the defective notice from the IT
            department?
          </div>
          <div className="content-paragraph">
            You will receive an email from the IT department with the subject
            line Important ‐ Rectify the defect in your Return of Income. The
            department also sends an SMS alert to the tax filer that the
            intimation notice has been sent to their registered email ID.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            How do I respond to a notice under section 139(9) when the tax
            payable is more than the tax paid in return received from the Income
            Tax Department?
          </div>
          <div className="content-paragraph">
            This error occurs if the tax payable in the return filed exceeds the
            tax paid. To resolve this error, the tax should be paid in full with
            interest to the Income-tax department in the revised return.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            Why does my ITR status suggest, 'no further action required as the
            latest return is taken for processing'?
          </div>
          <div className="content-paragraph">
            It means the return is error-free, and all the defects have been
            removed and taken up for processing.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            How do I pay my remaining income tax after receiving notice u/s
            139(9)?
          </div>
          <div className="content-paragraph">
            To pay the remaining income tax u/s 139(9) of the Income Tax Act,
            1961:
            <div className="content-ul">
              <li>
                Pay&nbsp;
                <a
                  href="https://tax2win.in/guide/income-tax-notice-us-143-1"
                  target="blank"
                >
                  taxes online
                </a>
                &nbsp;as you pay for self-assessment taxes.
              </li>
              <li>
                File your revised return and generate JSON L for the same.
              </li>
              <li>Then log in to the income tax portal.</li>
              <li>
                Go to the e-file dropdown and select e-file response u/s 139(9).
              </li>
              <li>Browse the JSON generated in the response.</li>
              <li>
                And revised return and response under section 139(9) is filed
              </li>
            </div>
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            Invalid returns u/s 139(9). Can I file it again as a fresh return
            for that AY?
          </div>
          <div className="content-paragraph">
            Notice u/s 139(9) of the income tax act is issued when the return is
            found defective, and a period of 15 days is provided to the assessee
            to resolve the same; however, if the assessee fails to do so, the
            return is considered as defective and treated as the return has
            never been filed. If the assessee wants to file a return later, he
            can do so by filing a belated return. <br />
            <br />
            But the last date for belated return is on or before three months
            before the end of the relevant Assessment Year (AY). For example,
            the ITR of FY 2021-2022 can be filed last up to 31.12.2023. <br />
            <br />
            In response to 139(9), I have filed a revised Income Tax Return. Do
            I need to respond to 139(9) also separately <br />
            <br />
            Normally, Compliance can be submitted with the Disagree option
            stating that Return has been Revised. Still, the action might differ
            depending upon your case, which our Tax Experts can further assist{" "}
            <br />
            <br />
            I have received notice u/s 139(9). My Form 26AS shows additional
            pension income received from the Army. Please let me know if it is
            taxable. I am currently receiving Form 16 for another job. <br />
            <br />
            Pension received from the armed force is fully exempt if the
            lump-sum pension amount is received. However, if the periodical
            pension is received from the armed forces, it is taxable. Further,
            the lump sum pension received by family members of the armed forces
            is fully exempt. Hence, you can reply to the notice accordingly.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            What is section 139(9) of the income tax act?{" "}
          </div>
          <div className="content-paragraph">
            In case incomplete or wrong information has been furnished while
            filing income tax return, then notice under section 139(9) of the
            income tax act is issued to the assessee. You are given a time
            period of 15 days to reply to this notice. If the assessee fails to
            respond to the notice, they can ask for an extension of the timeline
            by writing a letter to the department.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            When is a notice under section 142 issued by the income tax
            department?{" "}
          </div>
          <div className="content-paragraph">
            The income tax department can issue you notice u/s 142(1) if
            <div className="content-ul">
              <li>
                You have not filed your income tax return for the relevant
                assessment year or
              </li>
              <li>
                You have filed the income tax return, but the Assessing Officer
                requires you to submit some information or documents to the
                income tax department.
              </li>
            </div>
            You should file such a return within the given time period in the
            notice or furnish such documents and information as sought by the
            Assessing Officer.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            What is a unique number or document identification number in notice
            u/s 139(9)?
          </div>
          <div className="content-paragraph">
            While submitting a reply to notice u/s 139(9), you are required to
            quote a unique reference number, the Document Identification Number
            mentioned on your notice.
          </div>
          <div className="content-image">
            <img src={DefectiveReturn} alt="" />
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            What is error code rule 37BA in income tax return notice u/s 139(9)?{" "}
          </div>
          <div className="content-paragraph">
            While responding to notice u/s 139(9), error code rule 37BA is
            widely seen. This code means the total receipts shown under all
            heads of income in ITR are less than the gross receipts in
            your&nbsp;
            <a href="https://tax2win.in/guide/view-form-26as" target="blank">
              Form 26AS
            </a>
            .
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            What are the consequences of invalid/defective return u/s 139(9)?{" "}
          </div>
          <div className="content-paragraph">
            The various consequences of not responding to defective return
            communication u/s 139(9) are
            <div className="content-ul">
              <li>Your return can be invalidated</li>
              <li>Penalties & interest may be levied</li>
              <li>You might attract excess tax liability</li>
              <li>
                Loss of income tax exemptions, deductions, and carry-forward
                losses
              </li>
              <li>May attract litigations</li>
            </div>
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            What will happen if you won’t respond to notice u/s 139(9)?{" "}
          </div>
          <div className="content-paragraph">
            If you don’t respond timely to the notice for a defective return,
            your ITR for that relevant assessment year will be considered
            invalid. You will have to face the consequences like a penalty,
            interest, non-carry forward of losses, and loss of specific
            exemptions etc.
          </div>
        </div>
        <div className="content-section">
          <div className="content-subheading">
            How do I correct a defective income tax return?{" "}
          </div>
          <div className="content-paragraph">
            A defective return can be corrected by &nbsp;
            <a
              href="https://tax2win.in/guide/revised-income-tax-return"
              target="blank"
            >
              filing a revised return
            </a>
            &nbsp;or submission of response to a defective notice.
          </div>
        </div>
      </div>
      <hr />
      <div className="blog-footer">
        <div className="blog-author">
          <div className="blog-author-profile">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/b/b9/Dollar_sign_in_circle_cleaned_%28PD_version%29.green.svg"
              alt="TaxSarthi"
            />
          </div>
          <div className="blog-author-name">TaxSarthi</div>
        </div>
        <div className="next-button">
          <button>Next</button>
        </div>
      </div>
    </section>
  );
}

export default Section139_9;
